module.exports = __webpack_public_path__ + "img/pdf.ede71849.svg";